export default (initialTags: string[] = [], weekTagLabel: string | null = null, initialSlug = '') => ({
  week_post: false,
  syndicationModalOpen: false,
  mobileSettingsOpen: false,
  tagInput: '',
  tags: initialTags,
  postSlug: initialSlug,
  scrolled: false,

  init() {
    if (weekTagLabel) {
      this.$watch('tags', (v: string[]) => {
        this.week_post = v.some((t: string) => t.trim() === weekTagLabel);
      });
      this.week_post = initialTags.some((t: string) => t.trim() === weekTagLabel);
    }
  },

  addTag() {
    const t = (this.tagInput as string).trim().replace(/,$/, '');
    if (t && !(this.tags as string[]).includes(t)) (this.tags as string[]).push(t);
    this.tagInput = '';
  },

  removeTag(t: string) {
    this.tags = (this.tags as string[]).filter((x: string) => x !== t);
  },

  // Collapse the header chrome once the body is scrolled. Only collapse when
  // there's enough overflow that the reclaimed height can't push scrollTop back
  // under the expand threshold (which would make it flicker).
  onEditorScroll(e: Event) {
    const el = e.target as HTMLElement;
    const overflow = el.scrollHeight - el.clientHeight;
    if (!this.scrolled && el.scrollTop > 48 && overflow > 160) this.scrolled = true;
    else if (this.scrolled && el.scrollTop < 8) this.scrolled = false;
  },

  handleTagKey(e: KeyboardEvent) {
    if ((e.key === 'Enter' || e.key === ',') && (this.tagInput as string).trim()) {
      e.preventDefault();
      this.addTag();
    }
    if (e.key === 'Backspace' && !(this.tagInput as string) && (this.tags as string[]).length) {
      (this.tags as string[]).pop();
    }
  },
});
